export default __webpack_public_path__ + "static/media/31.24d5e477.svg";